export default state => ({
  ...state,
  sort: state.indicatives.sort,
  sortOrder: state.indicatives.sortOrder,
  indicatives: {
    ...state.indicatives,
    sort: undefined,
    sortOrder: undefined
  }
});
